import {Types} from './actions';
import initialState from './initialState';
import ReducerBuilder from "classes/ReducerBuilder";

const reducer = ReducerBuilder.make(initialState)
    .forType(Types.SUBMIT_COPY_CHALLENGE)
    .reduce((state, action) => {
        state.copyChallengeFormSubmitted = true;
    })
    .forType(Types.COPY_CHALLENGE_COMPLETE)
    .reduce((state, {challengeId}) => {
        // reset booleans
        state.copyChallengeFormSubmitted = false;
        state.copyingChallenge = false;

        state.createdChallengeId = challengeId;
        state.copyChallengeId = null;

        state.error = null;
        state.copyChallengePermalink = null;
    })
    .forType(Types.START_COPY_CHALLENGE)
    .reduce((state, action) => {
        state.copyingChallenge = true;
        state.createdChallengeId = null;
        state.copyChallengeId = action.copyChallengeId;
        state.copyChallengePermalink = action.permalink;
    })
    .forType(Types.END_COPY_CHALLENGE)
    .reduce((state, action) => {
        state.copyingChallenge = false;
        state.createdChallengeId = null;
        state.copyChallengeId = null;
        state.error = null;
        state.copyChallengePermalink = null;
    })
    .forType(Types.ERROR_COPYING_CHALLENGE)
    .reduce((state, action) => {
        state.error = action.error;
    })
    .build();

export default reducer;



// WEBPACK FOOTER //
// ./public/pages/BreakCopy/reducer.js